import React from 'react';
import IconWrapper from '../IconWrapper';
const WarningIcon = (props) => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'otherStories':
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M11 18h2v2h-2zM11 4h2v12h-2z" })));
        case 'weekday':
            return (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 20 20" }),
                React.createElement("path", { d: "M8 .5C3.9.5.5 3.9.5 8s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5S12.1.5 8 .5zm0 13C5 13.5 2.5 11 2.5 8S5 2.5 8 2.5 13.5 5 13.5 8 11 13.5 8 13.5z" }),
                React.createElement("path", { d: "M9 4.2H7V9h2V7.5zM9 10H7v2h2v-.625z" })));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 16 16" }),
                React.createElement("path", { d: "M8 .667l7.333 14.666H.667L8 .667zm0 1.49l-6.255 12.51h12.51L8 2.157zm0 9.635c.384 0 .683.299.683.683a.665.665 0 0 1-.683.672.665.665 0 0 1-.683-.672c0-.384.299-.683.683-.683zM8.501 6v4.96H7.5V6h1z" })));
    }
};
export default WarningIcon;
//# sourceMappingURL=WarningIcon.js.map